export function enter(cx, key, cb) {
  return cx !== null ? cx.enter(key, cb) : cb();
}
export function writeCheck(cx, check) {
  return cx !== null ? cx.write(check) : 0;
}
export function writeError(cx, check) {
  return {
    ok: false,
    value: writeCheck(cx, check)
  };
}
